import React, { useCallback, useEffect, useState, useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import 'admin-lte/plugins/datatables-bs4/css/dataTables.bootstrap4.min.css';
import 'datatables.net-dt/js/dataTables.dataTables';
import Select from '@atlaskit/select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { CustomInputDate } from '../../../../components/common/CustomInputDatepicker';
import { useForm, Controller } from 'react-hook-form';
import moment from 'moment';
import { ROLES } from '../../../../constants/user.constant';
import TranslateHelper from '../../../../helpers/TranslateHelper';
import departmentService from './services/department.service';
import { ToastTopEnd } from '../../../../helpers/ToastTimer';
import Swal from 'sweetalert2';
import ReactPagination from '../../../ReactPagination';
import { connect } from 'react-redux';
import Button from '@atlaskit/button';
import { vi } from 'date-fns/locale';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, styled, tableCellClasses } from '@mui/material';
import DepartmentDetail from './DepartmentDetail';
function Departments ({ role }) {
    const StyledTableCell = styled(TableCell)(() => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: '#dce8ff',
            color: '#1849A9',
            fontSize: 14
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14
        }
    }));

    const StyledTableRow = styled(TableRow)(() => ({
        '&:last-child td, &:last-child th': {
            border: 0
        },
        '& th, & td': {
            borderBottom: '1px solid rgb(118 55 255 / 10%)'
        }
    }));
    const customSwal = Swal.mixin({
        customClass: {
            cancelButton: 'btn btn-outline-danger',
            confirmButton: 'btn btn-primary ml-2'
        },
        buttonsStyling: false
    });
    const {
        register,
        handleSubmit,
        control,
        formState: { errors, isDirty, isValid },
        reset,
        setValue,
        clearErrors
    } = useForm({
        defaultValues: {
            businessUnits: [{ value: 1, label: '12' }],
            departmentHeads: [{ value: 1, label: '12' }]
        },
        mode: 'onChange'
    });
    const hideModalButtonRef = useRef();
    const [parentDepartments, setParentDepartments] = useState([]);
    const [departmentHeads, setDepartmentHead] = useState([]);
    const [departments, setDepartment] = useState();
    const [isEdit, setIsEdit] = useState();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [detail, setDetail] = useState(null);
    const closeModal = () => {
        setIsModalOpen(false);
    };

    const fetchManager = useCallback(() => {
        departmentService.getDepartmentHead().then((res) => {
            const list = res.data.data.map((item) => ({
                value: item._id,
                label: item.firstname + ' ' + item.lastname
            }));
            setDepartmentHead(list);
        });
    }, []);

    const fetchDepartment = useCallback((page = 1) => {
        departmentService.getAllDepartment({ page }).then((res) => {
            setDepartment(res.data.data);
            const list = res.data.data.items.map((item) => ({ value: item?._id, label: item?.name }));
            setParentDepartments(list);
        });
    }, []);

    useEffect(fetchDepartment, [fetchDepartment]);
    useEffect(fetchManager, [fetchManager]);

    const onSubmit = (formData) => {
        const data = {
            code: formData.code,
            name: formData.name,
            startedOn: formData.startedOn,
            parent: formData?.parent?.value,
            departmentHead: formData.departmentHead.value
        };
        handleCreateDepartment(data);
    };

    const handleCreateDepartment = async (data) => {
        if (isEdit) {
            try {
                await departmentService.updateDepartment(data, isEdit);
                ToastTopEnd.fire({
                    icon: 'success',
                    title: TranslateHelper.getMessage('respond.message.update.successed')
                });
                reset({
                    ...data,
                    name: '',
                    code: '',
                    startedOn: '',
                    parent: null,
                    departmentHead: null
                });
                hideModalButtonRef.current?.click();
                fetchManager();
                return fetchDepartment();
            } catch (error) {
                console.warn(error);
                ToastTopEnd.fire({
                    icon: 'error',
                    title:
                        error.response?.data?.message ||
                        TranslateHelper.getMessage('respond.message.failed')
                });
            }
        } else {
            try {
                await departmentService.createDepartment(data);
                ToastTopEnd.fire({
                    icon: 'success',
                    title: TranslateHelper.getMessage('respond.message.addnew.successed')
                });
                reset({
                    ...data,
                    name: '',
                    code: '',
                    startedOn: '',
                    parent: null,
                    departmentHead: null
                });
                hideModalButtonRef.current?.click();
                fetchManager();
                return fetchDepartment();
            } catch (error) {
                console.warn(error);
                ToastTopEnd.fire({
                    icon: 'error',
                    title:
                        error.response?.data?.message ||
                        TranslateHelper.getMessage('respond.message.failed')
                });
            }
        }
    };

    const handleDelete = (code) => {
        customSwal
            .fire({
                title: TranslateHelper.getMessage('button.name.common.delete') + ' ' + code + ' ?',
                icon: 'warning',
                showCancelButton: true,
                cancelButtonText: TranslateHelper.getMessage('button.name.common.cancel'),
                confirmButtonText: TranslateHelper.getMessage('button.name.common.yes'),
                reverseButtons: true
            })
            .then(async (result) => {
                if (result.isConfirmed) {
                    await departmentService.deleteDepartment(code);
                    ToastTopEnd.fire({
                        icon: 'success',
                        title: TranslateHelper.getMessage('respond.message.delete.successfully')
                    });
                    return fetchDepartment();
                }
            });
    };
    const thElements = ['Mã', 'Tên phòng ban', 'Ngày thành lập', 'Người lãnh đạo', 'Phòng ban cấp trên', ''];
    return (
        <>
            <Button
                type="button"
                className={role === 1 ? 'mb-3' : 'd-none'}
                onClick={() => { reset(); setIsEdit(undefined); }}
                data-toggle="modal"
                appearance='primary'
                data-target="#create-modal"
            >
                <FormattedMessage id="button.name.common.create" />
            </Button>
            <div className="modal fade" id={isEdit ? 'edit-department' : 'create-modal'}>
                <div className="modal-dialog modal-dialog-centered">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="modal-content custom-width">
                            <div className="modal-header">
                                <h5 className="modal-title">{!isEdit ? 'Create Department' : 'Edit Department'}</h5>
                                <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => clearErrors()}
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="form-group">
                                    <label htmlFor="name">
                                        Tên phòng ban
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            errors.name ? 'is-invalid form-control' : 'form-control'
                                        }
                                        {...register('name', {
                                            required: TranslateHelper.getMessage(
                                                'validation.error.required'
                                            ),
                                            pattern: {
                                                value: /^(?!\s+$)[a-zÀ-ȕ0-9(),  ]+$/gi,
                                                message: TranslateHelper.getMessage(
                                                    'validation.error.containSpecialCharacter'
                                                )
                                            }
                                        })}
                                        id="name"
                                        placeholder="Tên phòng ban"
                                    />
                                    {errors.name && (
                                        <span className="error text-danger">
                                            {errors.name.message}
                                        </span>
                                    )}
                                </div>
                                <div className="form-group">
                                    <label htmlFor="code">
                                        Mã
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            errors.code ? 'is-invalid form-control' : 'form-control'
                                        }
                                        {...register('code', {
                                            required: TranslateHelper.getMessage(
                                                'validation.error.required'
                                            ),
                                            pattern: {
                                                value: /^(?!$)[a-zÀ-ȕ0-9(),  ]+$/gi,
                                                message: TranslateHelper.getMessage(
                                                    'validation.error.containSpecialCharacter'
                                                )
                                            },
                                            maxLength: {
                                                value: 7,
                                                message: TranslateHelper.getMessage(
                                                    'validation.error.max7characters'
                                                )
                                            }
                                        })}
                                        id="code"
                                        placeholder="Mã phòng ban"
                                    />
                                    {errors.code && (
                                        <span className="error text-danger">
                                            {errors.code.message}
                                        </span>
                                    )}
                                </div>
                                <div className="form-group">
                                    <label htmlFor="startedOn" className='mr-2'>
                                        Ngày thành lập
                                    </label>
                                    <Controller
                                        control={control}
                                        rules={{
                                            required: true
                                        }}
                                        render={({ field: { onChange, value, ref } }) => (
                                            <DatePicker
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode='select'
                                                ref={ref}
                                                selected={value}
                                                onChange={onChange}
                                                customInput={<CustomInputDate />}
                                                id="startedOn"
                                                locale={vi}
                                                dateFormat="dd/MM/yyyy"
                                                maxDate={new Date()}
                                            />
                                        )}
                                        {...register('startedOn', { required: true })}
                                    />
                                    {errors.startedOn && (
                                        <span className="error text-danger">
                                            <FormattedMessage id="validation.error.select" />
                                        </span>
                                    )}
                                </div>
                                <div className="form-group">
                                    <label htmlFor="name">
                                        Phòng ban cấp trên
                                    </label>
                                    <Controller
                                        control={control}
                                        render={({ field: { onChange, value, ref } }) => (
                                            <Select
                                                ref={ref}
                                                options={parentDepartments}
                                                placeholder="Chọn phòng ban cấp trên"
                                                onChange={onChange}
                                                value={value}
                                            />
                                        )}
                                        name="parent"
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="departmentHead">
                                        Người lãnh đạo
                                    </label>
                                    <Controller
                                        control={control}
                                        rules={{
                                            required: true
                                        }}
                                        render={({ field: { onChange, value, ref } }) => (
                                            <Select
                                                ref={ref}
                                                options={departmentHeads}
                                                placeholder="Chọn người lãnh đạo"
                                                onChange={onChange}
                                                value={value}
                                            />
                                        )}
                                        name="departmentHead"
                                    />
                                    {errors.departmentHead && (
                                        <span className="error text-danger">
                                            <FormattedMessage id="validation.error.select" />
                                        </span>
                                    )}
                                </div>
                            </div>
                            <div className="modal-footer justify-content-flex-end">
                                <Button
                                    type="button"
                                    ref={hideModalButtonRef}
                                    data-dismiss="modal"
                                    onClick={() => clearErrors()}
                                >
                                    <FormattedMessage id="button.name.common.close" />
                                </Button>
                                <Button
                                    type="submit"
                                    appearance='primary'
                                    disabled={!isDirty || !isValid}
                                >
                                    {isEdit ? <FormattedMessage id="button.name.common.update" /> : <FormattedMessage id="button.name.common.create" />}
                                </Button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <TableContainer className='device-table' component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            {thElements.map((item, i) => (
                                <StyledTableCell key={i} align="center">{item}</StyledTableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {departments?.items?.map((item, i) => {
                            return (
                                <StyledTableRow key={i}>
                                    <StyledTableCell align="center">{item?.code}</StyledTableCell>
                                    <StyledTableCell align="center">{item?.name}</StyledTableCell>
                                    <StyledTableCell align="center">{moment(item?.startedOn).format('DD/MM/YYYY')}</StyledTableCell>
                                    <StyledTableCell align="center">{item?.departmentHead?.firstname + ' ' + item?.departmentHead?.lastname}</StyledTableCell>
                                    <StyledTableCell align="center">{item?.parent?.name}</StyledTableCell>
                                    <StyledTableCell>
                                        <Button className='mr-2' onClick={() => { setDetail(item); setIsModalOpen(true); }}>
                                            <i className="fa fa-eye"></i>
                                        </Button>
                                        {role === ROLES.MANAGER && (
                                            <>
                                                <Button className='mr-2'
                                                    data-toggle="modal"
                                                    onClick={ () => {
                                                        reset();
                                                        clearErrors();
                                                        setIsEdit(item?.code);
                                                        setValue('startedOn', new Date(moment(item?.startedOn).format('MM/DD/YYYY')));
                                                        setValue('parent', parentDepartments.filter((parent) => parent.value === item?.parent?._id));
                                                        setValue('departmentHead', departmentHeads.filter(dpH => dpH.value === item?.departmentHead?._id));
                                                        setValue('name', item?.name);
                                                        setValue('code', item?.code);
                                                    }}
                                                    data-target={'#edit-department'}
                                                >
                                                    <i className="fa fa-edit"></i>
                                                </Button>
                                                <Button onClick={() => handleDelete(item?.code)}>
                                                    <i className="far fa-trash-alt" aria-hidden="true"></i>
                                                </Button>
                                            </>
                                        )}
                                    </StyledTableCell>
                                </StyledTableRow>
                            );
                        })}
                    </TableBody>
                </Table>
                <DepartmentDetail open={isModalOpen} closeModal={closeModal} data={detail} />
            </TableContainer>
            {
                departments?.totalPages > 1 &&
                    <ReactPagination
                        totalPages={departments?.totalPages}
                        handlePageChange={(e, page) => fetchDepartment(page)}
                        pageNumber={departments?.page}
                    />
            }
        </>
    );
}

function mapStateToProps (state) {
    const { role } = state.auth;
    return {
        role
    };
}

export default connect(mapStateToProps)(Departments);
